const SEARCH_SORT_STRIP = {
	search: {
		dataAid: 'searchScrip',
		holdingPlaceholder: 'Search holdings',
		positionsPlaceholder: 'Search positions',
	},
	sort: {
		title: 'Sort',
		dataAid: 'sort',
	},
	pnlToggle: {
		overall: {
			dataAid: 'OveralLP&L',
			title: 'Overall P&L',
		},
		todays: {
			dataAid: 'todaysToggle',
			title: 'Today’s P&L',
		},
	},
	counter: {
		holding: {
			multipleText: 'Holdings',
			singleText: 'Holding',
			dataAid: 'holding',
		},
		position: {
			multipleText: 'Positions',
			singleText: 'Position',
			dataAid: 'position',
		},
	},
};

const SUMMARY_CARD = {
	overAllPnl: {
		title: 'Overall P&L',
		dataAid: 'overallP&LKey',
		valueDataAid: 'overallP&LValue',
	},
	invested: {
		title: 'Invested amount',
		dataAid: 'investedKey',
		valueDataAid: 'investedValue',
	},
	current: {
		title: 'Current value',
		dataAid: 'totalCurrentKey',
		valueDataAid: 'totalCurrentValue',
	},
	totalPnl: {
		title: 'Overall P&L',
		dataAid: 'totalKey',
		valueDataAid: 'unrealisedP&LValue',
		percDataAid: 'unrealisedP&Lpercentage',
	},
	todaysPnl: {
		title: 'Today’s P&L',
		dataAid: 'todaysP&LKey',
		valueDataAid: 'unrealisedP&LValue',
		percDataAid: 'unrealisedP&Lpercentage',
	},
};

const SORT_BOTTOMSHEET = {
	dataAid: 'sort',
	title: 'Sort',
	actionButton: {
		title: 'Reset',
		dataAid: 'link',
	},
};

const POSITIONS_BOTTOMSHEET = {
	status: {
		dataAid: 'orderType',
	},
	scripName: {
		dataAid: 'scripTicker',
	},
	amount: {
		dataAid: 'scripAmount',
	},
	exchange: {
		dataAid: 'exchange',
	},
	quantity: {
		title: 'Qty',
		keyDataAid: 'qtyKey',
		valueDataAid: 'qtyValue',
	},
	avg: {
		title: 'Avg',
		keyDataAid: 'priceKey',
		valueDataAid: 'priceValue',
	},
	ltp: {
		title: 'LTP',
		keyDataAid: 'ltp',
		valueDataAid: 'ltpValue',
		percentageDataAid: 'ltpPercentage',
	},
	positionDetailsBtn: {
		dataAid: 'viewDetails',
		title: 'View details',
	},
	openChartBtn: {
		dataAid: 'openChart',
		title: 'Chart',
	},
	addMoreCta: {
		dataAid: 'addMore',
		title: 'Add More',
	},
	buyCta: {
		dataAid: 'buy',
		title: 'Buy',
	},
	sellCta: {
		dataAid: 'sell',
		title: 'Sell',
	},
	exitCta: {
		dataAid: 'squareOff',
		title: 'Square off',
	},
};

const HOLDING_LIST_ITEM = {
	invested: {
		title: 'Invested',
		keyDataAid: 'investedKey',
		valueDataAid: 'investedValue',
	},
	scripTicker: {
		dataAid: 'scripTicker',
	},
	quantity: {
		title: 'Qty',
		keyDataAid: 'quantityKey',
		valueDataAid: 'quantityValue',
	},
	price: {
		title: 'Avg',
		keyDataAid: 'priceKey',
		valueDataAid: 'priceValue',
	},
	current: {
		title: 'Current',
		keyDataAid: 'currentKey',
		valueDataAid: 'currentValue',
	},
	amount: {
		dataAid: 'scripAmount',
	},
	percentage: {
		dataAid: 'scripPercentage',
	},
	ltp: {
		title: 'LTP',
		keyDataAid: 'ltpKey',
		valueDataAid: 'ltpValue',
		percDataAid: 'ltpPercentage',
	},
};

const POSITION_LIST_ITEM = {
	orderType: {
		dataAid: 'orderType',
	},
	scripTicker: {
		dataAid: 'scripTicker',
	},
	scripAmount: {
		dataAid: 'scripAmount',
	},
	exchange: {
		dataAid: 'exchange',
	},
	quantity: {
		title: 'Qty',
		dataAid: 'Qty',
		valueDataAid: 'qtyValue',
	},
	averagePrice: {
		title: 'Avg',
		dataAid: 'Avg',
		valueDataAid: 'priceValue',
	},
	ltp: {
		title: 'LTP',
		dataAid: 'ltp',
		valueDataAid: 'ltpValue',
		percentageDataAid: 'ltpPercentage',
	},
	holdingsTag: {
		dataAid: 'holdings',
	},
};

const NO_HOLDINGS = {
	title: {
		text: 'No holdings',
		dataAid: 'title',
	},
	subtitle: {
		text: 'Start your investment journey now!',
		dataAid: 'subtitle1',
	},
};

const NO_HOLDINGS_YET = {
	title: {
		text: 'No holdings yet!',
		dataAid: 'title',
	},
	subtitle1: {
		text: 'Start investing with',
		dataAid: 'subtitle1',
	},
	subtitle2: {
		text: ' most bought stocks on Fisdom',
		dataAid: 'subtitle2',
	},
};

const NO_POSITIONS = {
	title: {
		text: 'No active positions',
		dataAid: 'title',
	},
	subtitle: {
		text: 'Your active positions will be listed here.',
		dataAid: 'subtitle1',
	},
};

const FETCH_ERROR = {
	title: 'Unable to load data',
	cta: 'Refresh',
};

const MISCELLANEOUS = {
	screenDataAid: 'portfolio',
	holdingsTabTitle: 'Holdings',
	positionsTabTitle: 'Positions',
};

const PORTFOLIO_TABS = {
	HOLDINGS: MISCELLANEOUS.holdingsTabTitle,
	POSITIONS: MISCELLANEOUS.positionsTabTitle,
};

const STOCKS_PORTFOLIO_LANDING = {
	...MISCELLANEOUS,
	SORT_BOTTOMSHEET,
	SEARCH_SORT_STRIP,
	SUMMARY_CARD,
	POSITION_LIST_ITEM,
	HOLDING_LIST_ITEM,
	POSITIONS_BOTTOMSHEET,
	NO_HOLDINGS,
	NO_HOLDINGS_YET,
	NO_POSITIONS,
	FETCH_ERROR,
	PORTFOLIO_TABS,
};

export default STOCKS_PORTFOLIO_LANDING;
